import env from '@beam-australia/react-env';
export const REACT_APP_API_HOST = env('API_HOST');
export const REACT_APP_TOKEN = env('TOKEN');
export const REACT_APP_NAME = env('NAME');
export const REACT_APP_MOBILE_NUMBER = env('MOBILE_NUMBER');
export const REACT_APP_COUNTRY_CODE = env('COUNTRY_CODE');
